import { cn } from "../../../../utils/utils";

/**
 * Reusable white card with optional title/subtitle header + right-slot.
 * Used across report widgets for consistent spacing + borders.
 */
const ReportSectionCard = ({
  title,
  subtitle,
  right,
  className,
  bodyClassName,
  children,
}) => {
  const hasHeader = title || subtitle || right;
  return (
    <div
      className={cn(
        "rounded-xl border border-gray-200 bg-white",
        className,
      )}
    >
      {hasHeader && (
        <div className="flex items-start justify-between gap-3 px-4 pt-4 pb-2">
          <div className="min-w-0">
            {title && (
              <h3 className="text-sm font-semibold text-gray-900 leading-5">
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>
            )}
          </div>
          {right && <div className="shrink-0">{right}</div>}
        </div>
      )}
      <div className={cn(hasHeader ? "px-4 pb-4" : "p-4", bodyClassName)}>
        {children}
      </div>
    </div>
  );
};

export default ReportSectionCard;
